module.exports = __webpack_public_path__ + "static/img/meizu16X.3ea9ce34.png";